/* eslint-disable import/no-default-export */
import { MockList } from '@graphql-tools/mock';
import Chance from 'chance';

import currentLocation from './CurrentLocation';
import currentLocation2 from './CurrentLocation2';
import languageProficiencies from './LanguageProficiencies';
import nextRolePreferredLocations from './NextRolePreferredLocations';
import personalDetails from './PersonalDetails';
import preferredLocations2 from './PreferredLocations2';
import rightsToWork from './RightToWork';
import summary from './Summary';
import yearsOfExperience from './YearsOfExperience';

const chance = new Chance();

export default () => ({
  personalDetails: () => personalDetails(),
  currentLocation: () => currentLocation(),
  currentLocation2: () => currentLocation2(),
  emailAddress: () => chance.email(),
  minimumProfile: () => chance.bool(),
  qualifications: () => new MockList([1, 4]),
  roles: () => new MockList([0, 4]),
  savedSearches: () => new MockList([0, 10]),
  skills: () => new MockList([0, 20]),
  careerObjectives: () => summary(),
  nextRolePreferredLocations: () => nextRolePreferredLocations(),
  preferredLocations2: () => preferredLocations2(),
  resumes: () => new MockList([0, 10]),
  rightsToWork: () => rightsToWork(),
  licences: () => new MockList([0, 3]),
  languageProficiencies: () => languageProficiencies(),
  yearsOfExperience: () => yearsOfExperience(),
});
